import { BypassBlockComponent } from '@rd/core/components/bypass-block/bypass-block.component';
import { FooterComponent } from '@rd/core/components/footer/footer.component';
import { SideNavComponent } from '@rd/core/components/side-nav/side-nav.component';
import { HeaderComponent } from '@rd/core/containers/header/header.component';
import { DialogDefaultTemplateComponent } from '@rd/popup/components/default-template/default-template.component';
import { DialogComponent } from '@rd/popup/components/dialog/dialog.component';
import { LinkComponent } from '@rd/shared-legacy/components/link/link.component';

export let componentMap = {
  'core-bypass-block': BypassBlockComponent,
  'core-footer': FooterComponent,
  'core-header': HeaderComponent,
  'core-side-nav': SideNavComponent,
  'popup-default-template': DialogDefaultTemplateComponent,
  'popup-dialog': DialogComponent,
  'shared-link': LinkComponent,
};

export const changeComponentMap = (newMap: { [key: string]: any }): void => {
  componentMap = {
    ...componentMap,
    ...newMap,
  };
};
